import React from 'react'
import { AppRetailerBlock } from "@components"


export default function sitesHomeColumn() {
	return {
		name: 'site',
		label: 'Website',
		render: (value, { market, ico }) => {
			return <AppRetailerBlock retailer={value} country={market} icon={ico}/>
		}
	}
}